import React, { useState } from "react";
import { FaFileWord } from "react-icons/fa";
import { ReactComponent as QuoteIcon } from "../../../../assets/images/quote-icon.svg";
import { useAlerts } from "@/hooks/useAlerts";

const WordAlertCard = ({
  date,
  title,
  timestamp,
  name,
  content,
  used_word,
  currentAlert,
}) => {
  const { markAlertAsRead, markAlertAsUnread } = useAlerts();
  const [isToggling, setIsToggling] = useState(false);

  const handleToggleReadStatus = async (alert) => {
    if (!alert?._id) return;

    try {
      setIsToggling(true);
      const alertId = alert._id.toString();

      if (alert.read) {
        markAlertAsUnread(alertId);
      } else {
        markAlertAsRead(alertId);
      }
    } catch (error) {
    } finally {
      setIsToggling(false);
    }
  };

  return (
    <div className="flex items-center w-full sm:items-start mb-4 sm:mb-5 relative sm:will-change-auto gap-3 sm:gap-4 md:gap-5">
      <div className="hidden lg:flex flex-row gap-2 sm:gap-3 items-center justify-center w-28 sm:w-32 md:w-36">
        <span className="text-gray-500 font-semibold text-sm sm:text-base md:text-lg mt-1 mb-1">
          {date}
        </span>
        <div className="flex flex-col items-center">
          <div className="w-0.5 h-16 sm:h-20 bg-[#E0E3E8] z-0" />
          <div className="bg-[#6366f1] rounded-full p-1 sm:p-2 flex items-center justify-center w-5 h-5 sm:w-7 sm:h-7 mb-1 mt-1">
            <FaFileWord className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
          </div>
          <div className="w-0.5 h-16 sm:h-20 bg-[#E0E3E8] z-0" />
        </div>
      </div>

      <div className="flex-1 w-full">
        <div className="border border-[#DDDDDD] shadow-sm rounded pt-3 sm:pt-4 mb-1 transition-colors duration-300">
          <div className="px-0">
            <div
              className={`${
                currentAlert?.read
                  ? "bg-gray-300 text-gray-600"
                  : "bg-[#6366f1] text-white"
              } 
              text-sm sm:text-base font-semibold py-2 sm:py-3 gap-2 w-full flex justify-between items-center mb-1 px-3 sm:px-5 md:px-8`}
            >
              <span className="font-semibold text-base sm:text-lg md:text-xl">
                {title}
              </span>
              <button
                className={`hidden sm:flex text-xs sm:text-sm text-right transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  isToggling ? "opacity-60" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleToggleReadStatus(currentAlert);
                }}
                disabled={isToggling}
              >
                {currentAlert?.read ? "Mark as Unread" : "Mark as Read"}
              </button>
            </div>
            <div className="flex justify-between items-center px-3 py-2 sm:px-5 md:px-8">
              <span className="text-gray-500 text-sm md:text-base">
                {timestamp}
              </span>
              <button
                className={`sm:hidden text-xs flex text-right text-[#256AA6] transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  isToggling ? "opacity-60" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleToggleReadStatus(currentAlert);
                }}
                disabled={isToggling}
              >
                {currentAlert?.read ? "Mark as Unread" : "Mark as Read"}
              </button>
            </div>

            <div className="bg-[#F8FAFB] rounded py-2 sm:py-3 mb-3 sm:mb-3 px-3 sm:px-5 md:px-8">
              <div className="text-xs sm:text-sm mb-2 sm:mb-3 uppercase font-semibold tracking-wide">
                What {name} Wrote
              </div>

              <div className="relative">
                <div className="absolute top-0 left-0">
                  <QuoteIcon className="w-5 h-4 sm:w-6 sm:h-5 text-[#2C3E50]" />
                </div>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed ml-6 sm:ml-8">
                  {content &&
                    (() => {
                      // Normalize `used_word` to always be an array
                      const words = Array.isArray(used_word)
                        ? used_word
                        : [used_word];

                      //Escape regex special chars in each word
                      const escapeRegex = (s) =>
                        s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

                      const regex = new RegExp(
                        `\\b(${words.map(escapeRegex).join("|")})\\b`,
                        "gi",
                      );

                      return content.split(regex).map((part, index) =>
                        words.some(
                          (word) => part.toLowerCase() === word.toLowerCase(),
                        ) ? (
                          <span key={index} className="font-bold underline">
                            {part}
                          </span>
                        ) : (
                          part
                        ),
                      );
                    })()}
                </p>
              </div>
            </div>
          </div>

          <div className="text-sm sm:text-base md:text-lg font-semibold py-3 sm:py-4 px-4 sm:px-5 md:px-8 flex items-center gap-2 w-full rounded border-t border-[#DDDDDD]">
            <FaFileWord className="w-3 h-3 sm:w-4 sm:h-4" />
            Word Alert
          </div>
        </div>
      </div>
    </div>
  );
};

export default WordAlertCard;
